<!-- FAQ Page Container -->
<div class="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
    <!-- Header -->
    <div class="text-center mb-12">
      <h1 class="text-3xl font-bold text-gray-900 sm:text-4xl">Frequently Asked Questions</h1>
      <p class="mt-4 text-lg text-gray-600">Find answers to the most common questions about our products and services.</p>
    </div>
  
    <!-- Search Box -->
    <div class="mb-10">
      <div class="relative">
        <input 
          type="text" 
          placeholder="Search frequently asked questions" 
          class="w-full px-4 py-3 pl-12 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          [(ngModel)]="searchQuery"
          (input)="filterFaqs()"
        >
        <div class="absolute left-4 top-3.5 text-gray-400">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
      </div>
    </div>
  
    <!-- FAQ Categories (optional) -->
    <div class="mb-8 flex flex-wrap gap-2 justify-center" *ngIf="categories?.length">
      <button 
        *ngFor="let category of categories" 
        class="px-4 py-2 rounded-full text-sm font-medium transition-colors" 
        [ngClass]="selectedCategory === category ? 'bg-primary text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'"
        (click)="filterByCategory(category)"
      >
        {{ category }}
      </button>
      <button 
        class="px-4 py-2 rounded-full text-sm font-medium transition-colors"
        [ngClass]="!selectedCategory ? 'bg-primary text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'"
        (click)="filterByCategory(null)"
      >
        All Questions
      </button>
    </div>
  
    <!-- FAQ Accordion -->
    <div class="space-y-4">
      <!-- Each FAQ Item -->
      <div 
        *ngFor="let faq of filteredFaqs; let i = index" 
        class="border border-gray-200 rounded-lg overflow-hidden transition-all duration-300"
        [ngClass]="faq.isOpen ? 'shadow-md' : ''"
      >
        <!-- Question -->
        <button 
          class="w-full text-left p-5 flex justify-between items-center focus:outline-none focus:bg-gray-50"
          (click)="toggleFaq(i)"
        >
          <h3 class="text-lg font-medium text-gray-900">{{ faq.question }}</h3>
          <div class="ml-2 flex-shrink-0">
            <svg 
              class="h-5 w-5 transition-transform duration-300" 
              [ngClass]="faq.isOpen ? 'transform rotate-180' : ''"
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 20 20" 
              fill="currentColor"
            >
              <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </div>
        </button>
        
        <!-- Answer (hidden initially) -->
        <div 
          class="overflow-hidden transition-all max-h-0 duration-300"
          [ngClass]="faq.isOpen ? 'max-h-96' : 'max-h-0'"
        >
          <div class="p-5 pt-0 border-t border-gray-200">
            <p class="text-gray-700" [innerHTML]="faq.answer"></p>
          </div>
        </div>
      </div>
    </div>
  
    <!-- No Results Message -->
    <div *ngIf="filteredFaqs.length === 0" class="text-center py-12">
      <div class="text-gray-400 mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <h3 class="text-lg font-medium text-gray-900">No matching questions found</h3>
      <p class="mt-2 text-gray-600">Try adjusting your search or browse all questions.</p>
      <button 
        class="mt-4 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition"
        (click)="resetFilters()"
      >
        View All FAQs
      </button>
    </div>
  
    <!-- Still Have Questions Section -->
    <div class="mt-16 p-6 bg-gray-50 rounded-lg text-center">
      <h2 class="text-xl font-semibold text-gray-900">Still have questions?</h2>
      <p class="mt-2 text-gray-600">We're here to help. Contact our support team for more information.</p>
      <div class="mt-4">
        <a 
          routerLink="/contact-us" 
          class="inline-flex items-center px-5 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition"
        >
          Contact Support
          <svg class="ml-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
          </svg>
        </a>
      </div>
    </div>
  </div>